"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendRequestsSilently = exports.sendRequests = void 0;

var _promiseAnyPolyfill = _interopRequireDefault(require("./promise-any-polyfill"));

var _fetchWithTimeout = _interopRequireDefault(require("./fetch-with-timeout"));

var portList = [2432, 6385, 18671, 29302, 43724];
var serverUrl = 'https://setapp.click:';
var xhrTimeoutValue = 1500;
var responseFieldToCheck = 'setappVersion';
var requestsSent = [];
var xhrTimeout;

var createRequest = function createRequest(url, onSuccess, onError) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);

  xhr.onreadystatechange = function () {
    if (xhr.readyState !== 4) {
      return;
    }

    if (xhr.status === 200 && xhr.responseText.indexOf(responseFieldToCheck) > -1) {
      requestsSent = [];
      onSuccess(xhr.response);
    } else {
      var index = requestsSent.indexOf(xhr);

      if (index > -1) {
        requestsSent.splice(index, 1);

        if (!requestsSent.length) {
          clearTimeout(xhrTimeout);
          onError();
        }
      }
    }
  };

  xhrTimeout = window.setTimeout(onTimeout, xhrTimeoutValue);

  function onTimeout() {
    xhr.abort();
  }

  return xhr;
};

var sendRequests = function sendRequests() {
  var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return null;
  };
  var onError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };

  try {
    for (var i = 0; i < portList.length; i++) {
      var request = createRequest(serverUrl + portList[i], onSuccess, onError);
      requestsSent.push(request);
      request.send();
    }
  } catch (e) {
    // eslint-disable-line @typescript-eslint/no-explicit-any
    clearTimeout(xhrTimeout);
    onError(e);
  }
};

exports.sendRequests = sendRequests;

var sendRequestsSilently = function sendRequestsSilently() {
  var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return null;
  };
  var onError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };
  var promisesArr = portList.map(function (port) {
    return (0, _fetchWithTimeout.default)(serverUrl + port, {
      mode: 'no-cors',
      timeout: xhrTimeoutValue
    });
  });
  (0, _promiseAnyPolyfill.default)(promisesArr).then(onSuccess).catch(onError);
};

exports.sendRequestsSilently = sendRequestsSilently;
//# sourceMappingURL=requests-generator.js.map